import { Component, Input, Output, Injectable, EventEmitter } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class MenuSharedService {
   private menuRefreshSubject = new Subject<boolean>();

  constructor() {
    console.log('MenuSharedService started');
  }

  refreshMenu(): void {
    console.log('Menu refresh triggered');
    this.menuRefreshSubject.next(true);
  }

  onMenuRefresh(): Observable<boolean> {
    return this.menuRefreshSubject.asObservable();
  }

     
} 